import { compose, lifecycle, withState } from 'recompose'
import { loadBreadPaymentSdk, runBreadPayment, injectDynamicParameters } from '../helpers'
import BreadPaymentsBanner from './BreadPaymentsBanner'
import isEqual from 'lodash/isEqual'

const withDynamicContentState = withState('dynamicContent', 'setDynamicContent', null)

const withLifeCycle = lifecycle({
  componentDidMount() {
    const { content, totalPrice, setDynamicContent } = this.props
    setDynamicContent(injectDynamicParameters({ content, totalPrice }))
  },
  componentDidUpdate({ totalPrice: prevTotalPrice, dynamicContent: prevDynamicContent }) {
    const { totalPrice, dynamicContent } = this.props

    if (!isEqual(totalPrice, prevTotalPrice)) {
      loadBreadPaymentSdk(() => runBreadPayment(totalPrice))
    }

    if (!isEqual(dynamicContent, prevDynamicContent)) {
      loadBreadPaymentSdk(() => runBreadPayment())
    }
  }
})

export default compose(
  withDynamicContentState,
  withLifeCycle)(BreadPaymentsBanner)
